import React from "react";
import WorkoutAttachments from "./WorkoutAttachments";

const ModalViewAttachmets = ({ wokroutId, programId, setShowModal }) => {
  return (
    <div className="trainer-modal-eventWrapper">
      <div className="trainer-modal trainer-modal-lg">
        <div className="close" onClick={() => setShowModal(false)}>
          <i className="fa fa-times"></i>
        </div>

        <WorkoutAttachments workoutId={wokroutId} programId={programId} />
      </div>
    </div>
  );
};

export default ModalViewAttachmets;
